module.exports = __webpack_public_path__ + "static/media/iconStudents.c3e59308.svg";